'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFlightTakeoff = function ActionFlightTakeoff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z' })
  );
};
ActionFlightTakeoff = (0, _pure2.default)(ActionFlightTakeoff);
ActionFlightTakeoff.displayName = 'ActionFlightTakeoff';

exports.default = ActionFlightTakeoff;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/flight-takeoff.js
 ** module id = 1022
 ** module chunks = 0
 **/